// Small helpers shared by the Support & FAQ redesign preview views.
// Real Zendesk articles only provide raw HTML bodies (no plain-text excerpt
// field), so we strip tags and truncate for the card/list previews.
export function excerpt(html, maxLen = 110) {
  if (!html) return "";
  const text = html
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (text.length <= maxLen) return text;
  return text.slice(0, maxLen).trim() + "…";
}
